import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabledNonBlocking',
            paramsInheritanceStrategy: 'always',
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'top',
            scrollOffset: [0, 0],
        }),
    ],
    exports: [RouterModule],
})
export class VirsekerRoutingModule {}
